module.exports = __webpack_public_path__ + "static/img/son4.d60f64ae.jpg";